import React from "react";
import { formatCurrency } from "../../utils/format";
import "./ValueItem.css";

interface Props {
  data: any;
  paramType?: string;
  description?: string;
  valueItemCustomClass?: string;
  valueItemDescriptionCustomClass?: string;
}
const ValueItem: React.FC<Props> = ({
  data,
  paramType,
  description,
  valueItemCustomClass = "",
  valueItemDescriptionCustomClass = "",
}) => {
  const value = formatCurrency(Number(data));

  if (data !== null && data !== 0) {
    return (
      <div className="value-item-container">
        <div className={`value-item-currency ${valueItemCustomClass}`}>
          {value}
        </div>
        <div
          className={`value-item-description ${valueItemDescriptionCustomClass}`}
        >
          {value && paramType + (description ? description : " ")}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default ValueItem;
